/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

let targetName = "development"


let rootDomain = ""

if (targetName === "development") {
    // atagon.dev
    rootDomain = "atagon.dev"
} else if (targetName === "production") {
    // atagon.app
    rootDomain = "atagon.app"
}


export {rootDomain}